// extracted by mini-css-extract-plugin
export default {"dnb_menu_content_wrapper":"MenuTab-module--dnb_menu_content_wrapper--6a47a"};